<template lang="pug">
    v-autocomplete(dense 
        v-model="dataDenom" 
        :disabled="disabled"
        :readonly="readonly" 
        :label="label" 
        :rules="rules"
        :items="listData" 
        item-text="description" 
        item-value="denomId" 
        @change="onSelect" 
        :required = "required")
</template>
<script>
export default {
    name: "FSelectDenom",
    props: [
        "value",
        "disabled",
        "readonly",
        "label",
        "rules",
        "required",
        "productId"
    ],
    data() {
        return {
            dataDenom: {},
            listData: []
        }
    },
    mounted() {
        this.doInit(this.value);
    },
    watch: {
        value(val){
            this.doInit(val);
        },
        productId(val){
            this.doLoad()
        }
    },
    methods: {
        doInit(values){
            this.dataDenom = values ? values : null;
            this.doLoad();
        },
        doLoad(){
            if (this.productId) {
                this.$http.get("/api/parameter/denom/" + this.productId).then(success => {
                    this.listData = success.data;
                });
            }else{
                this.listData = []
            }
        },
        onSelect() {
            this.$emit("input", this.dataDenom);
            this.$emit("select", this.dataDenom);
            this.$emit("denom", this.valueData());
        },
        valueData(){
            let result = null;
            this.listData.map(element => {
                if (this.dataDenom === element.denomId) {
                    result = element;
                }
            });
            return result;
        },
    },
}
</script>